export const MAX_BATCH_ORS_SMARTLINKS = 5;
export const MAX_CONCURRENT_ORS_CALLS = 3;
export const DEFAULT_ORS_TIMEOUT = 500;
